// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3xvl6","alert":"SettungsInbox_alert__2YJeW"};